import httpHubless from 'hub-http/clients/noPortalApiClient';
const API_BASE = 'security-phone-numbers/v1';
export function getConfiguration() {
  return httpHubless.get(`${API_BASE}/setup`);
}
export function configure(phoneNumber) {
  return httpHubless.post(`${API_BASE}/setup/configure`, {
    data: {
      phoneNumber
    }
  });
}
export function resendCode(securityPhoneNumber) {
  return httpHubless.put(`${API_BASE}/setup/resend-code`, {
    data: {
      phoneNumber: securityPhoneNumber.info,
      setupTime: securityPhoneNumber.setupTime
    }
  });
}
export function confirm(securityPhoneNumber, codeAttempt) {
  return httpHubless.put(`${API_BASE}/setup/confirm`, {
    data: {
      phoneNumber: securityPhoneNumber.info,
      setupTime: securityPhoneNumber.setupTime,
      codeAttempt
    }
  });
}
export function validatePhoneNumber(number) {
  return httpHubless.get(`${API_BASE}/setup/validate/${number}`);
}
export function edit(phoneNumber) {
  return httpHubless.put(`${API_BASE}/setup/update`, {
    data: {
      phoneNumber
    }
  });
}
export function deleteNumber() {
  return httpHubless.delete(`${API_BASE}/setup/`);
}